import React from 'react';
import './styles.scss';
import cx from 'classnames';

const Spinner = ({ width, height, minWidth, minHeight, size, className }) => {
  return <div className={cx('loader', className)} style={{ width, height, minWidth, minHeight, borderWidth: size }} />;
};

export default Spinner;
